export const textsQuantities = [
  new Array(7).fill('text'),
  new Array(5).fill('text'),
];
